import Ccmr from './Ccmr.component';

export default Ccmr;
